import React, { useState } from "react";
import { ActionOption } from "../utils";
import OptionsPopup from "./OptionsPopup";

interface Props {
  options: ActionOption[];
}

const OptionsButtonAndPopup: React.FC<Props> = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="relative">
      <button
        className="w-6 h-6 bg-white rounded-full border border-gray-300 flex justify-center items-center text-gray-600"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="h-0.5 w-0.5 bg-gray-500 rounded-full"></div>
        <div className="h-0.5 w-0.5 bg-gray-500 rounded-full mx-1"></div>
        <div className="h-0.5 w-0.5 bg-gray-500 rounded-full"></div>
      </button>
      <OptionsPopup
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        positionStyle={{ top: 0, left: 0 }}
        options={options}
      />
    </div>
  );
};

export default OptionsButtonAndPopup;
